import React from "react";
import {
  // Customizable Area Start
  Chip,
  Radio,
  styled,
  Select,
  MenuItem,
  Checkbox,
  Snackbar,
  TextField,
  FormGroup,
  MenuProps,
  InputAdornment,
  FormControlLabel,
  Switch,
  Box,
  IconButton,
  Button,
  // Customizable Area End
} from "@material-ui/core";
import { calenderIcon } from "../../CfPriceList/src/assets";
import { Formik, FormikProps, FormikValues } from "formik";

import {
  Add as AddIcon,
  Delete as DeleteIcon,
  CalendarToday as CalendarIcon,
} from "@material-ui/icons";

import GoldenPointCreateController, {
  // Customizable Area Start
  IOption,
  ImageInterface,
  configJSON,
  Props,
  S,
  usageTypes,
  statusTypes,
  itemTypes,
  offerTypes,
  daysOfWeek,
  // Customizable Area End
} from "./GoldenPointCreateController.web";

import CustomImageRadioDropdown from "./CustomImageRadioDropdown";

// Customizable Area Start
import DateFnsUtils from "@date-io/moment";
import { Alert } from "@material-ui/lab";
import {
  DatePicker,
  MuiPickersUtilsProvider,
  TimePicker,
} from "@material-ui/pickers";
import AutocompleteSelect from "../../../components/src/AutocompleteSelect.web";
import { CommonIcomSearchComponent } from "../../../components/src/customComponents/CommonIcomSearchComponent";
import CustomLoader from "../../../components/src/customComponents/CustomLoader.web";
import { CustomSearchableMultiSelect } from "../../../components/src/customComponent/CustomSearchableMultiSelect.web";
import moment from "moment";

const Strings = {
  pageTitle: "Golden Point",
  create: "Create",
  edit: "Edit",
  save: "Save",
  add: "Add",
  cancel: "Cancel",
  goldenPointSaved: "Golden point saved successfully",
  goldenPointUpdate: "Golden point updated successfully",
  somethingWentWrong: "Something went wrong",
  selectDay: "Select Day",
  goldenPointName: "Golden Point Name",
  goldenPointNameArabic: "Golden Point Name (Arabic)",
  goldenPointTextEn: "Golden Point Description (English)",
  goldenPointTextAr: "Golden Point Description (Arabic)",
  receiptText: "Receipt Text",
  region: "Region",
  area: "Area",
  section: "Section",
  services: "Services",
  product: "Product",
  platform: "Platform Type",
  store: "Store",
  usageType: "Usage Type",
  noOfOrders: "Number of Orders",
  startDate: "Start Date",
  endDate: "End Date",
  status: "Status",
  basePoint: "Base Points",
  bonusPoint: "Bonus Points",
  totalPoint: "Total Points",
  vatPoint: "Vat Points",
  finalPrice: "Final Price",
  price: "Price",
  tax: "Tax",
  taxAmount: "Tax Amount",
  purchaseStartDate: "Purchase Start Date",
  purchaseEndDate: "Purchase End Date",
  startDateBase: "Start Date Base",
  endDateBase: "End Date Base",
  startDateBonus: "Start Date Bonus",
  endDateBonus: "End Date Bonus",
  expiryDaysBase: "Expiry Days Base",
  expiryDaysBonus: "Expiry Days Bonus",
  useNumberOfDays: "Number of days",
  enterNumberOfDays: "Enter number of days",
  startDateFreewash: "Start Date Free Wash",
  endDateFreeWash: "End Date Free Wash",
  freeWashProduct: "Free Wash Product",
  freeWashProductQty: "Free Wash Product Quantity",
  freeWashProductDescription: "Free Wash Product Description",

  availableTime: "Available Time",
  availableDay: "Available Day",

  excludedDays: "Excluded Days",
  excludedTimes: "Excluded Times",

  selectRegion: "Select Region",
  selectArea: "Select Area",
  selectSection: "Select Section",
  selectServices: "Select Services",
  selectProduct: "Select Product",
  selectPlatform: "Select Platform",
  selectStore: "Select Store",
  selectUsageType: "Select usage type",
  enterNoOfOrders: "Enter number of orders",
  selectStatus: "Select status",
  enterAmount: "Enter amount",
  enterPoint: "Enter Points",
  enterItems: "Enter minimum items",
  selectDays: "Select days",
  selectDate: "Select date",
  enterReason: "Enter reason",
  selectStartTime: "Select start time",
  selectEndTime: "Select end time",
  selectFreeWashProduct: "Select free wash product",
  enterGoldenPointName: "Enter Golden Point Name",
  enterGoldenPointNameArabic: "Enter Golden Point Name (Arabic)",
  enterGoldenPointText: "Enter Golden Point Description",
  enterReceiptText: "Enter Receipt Text",
  enterBasePoint: "Enter Base Point",
  enterBonusPoint: "Enter Bonus Point",
  enterPrice: "Enter Price",
  availableDays: "Available Days",
  mobileDescription: "Mobile Description",
  isRedeem: "Is Redeem",
};
// Customizable Area End

class GoldenPointCreate extends GoldenPointCreateController {
  constructor(props: Props) {
    super(props);
  }

  // Customizable Area Start

  renderExcludedTimes = () => {
    const { data, error } = this.state;
    const excludedTimes = data.attributes.available_times.filter(
      (item) => !item._destroy
    );

    return (
      <DynamicSection>
        <SectionHeader>
          <TextLabel>{Strings.availableTime}</TextLabel>
          <IconButton
            size='small'
            onClick={this.addExcludedTime}
            style={{ color: "#204B9C" }}
          >
            <AddIcon />
          </IconButton>
        </SectionHeader>
        {excludedTimes.map((item, index) => (
          <DynamicItemRow key={index}>
            <TextField
              type='time'
              value={item.start_time}
              onChange={(e) =>
                this.updateExcludedTime(index, "start_time", e.target.value)
              }
              variant='outlined'
              fullWidth
              style={{ marginRight: 8 }}
              InputLabelProps={{ shrink: true }}
              inputProps={{ step: 300 }}
            />
            <TextField
              type='time'
              value={item.end_time}
              onChange={(e) =>
                this.updateExcludedTime(index, "end_time", e.target.value)
              }
              variant='outlined'
              fullWidth
              style={{ marginRight: 8 }}
              InputLabelProps={{ shrink: true }}
              inputProps={{ step: 300 }}
            />
            {excludedTimes.length > 1 && (
              <IconButton
                size='small'
                onClick={() => this.removeExcludedTime(index)}
                style={{ color: "#EC4E20" }}
              >
                <DeleteIcon />
              </IconButton>
            )}
          </DynamicItemRow>
        ))}
        {error.available_times && (
          <ErrorLabel>{error.available_times}</ErrorLabel>
        )}
      </DynamicSection>
    );
  };

  render() {
    // Customizable Area Start
    const {
      data,
      error,
      isLoading,
      isSaveLoader,
      noData,
      saveStatus,
      vat,
      // promotionTypes,
      regionList,
      areaList,
      sectionList,
      serviceList,
      productList,
      platformList,
      storeList,
      selectedRegions,
      selectedAreas,
      selectedSections,
      selectedServices,
      selectedPlatforms,
      selectedPlatform,
      platformSelectedOptionForList,
      selectedStores,
      selectedStoresForList,
      selectedImage,
      selectedImageForGoldenPoint,
      // showEndDate,
      regionSelectedData,
      selectedRegionsForList,
      areaSelectedData,
      selectedProducts,
      selectedFreeWashProducts,
      selectedAreasForList,
      selectedProductsForList,
      selectedFreeWashProductsForList,
      sectionSelectedData,
      selectedSectionsForList,
      sectionLists,
      selectedServicesForList,
      serviceOptions,
      isSectionSelectAll,
      availableDayList,
      excludeDayList,
      mobileDescription,
    } = this.state;

    const {
      name,
      name_arabic,
      golden_point_text_en,
      golden_point_text_ar,
      receipt_text,
      base_points,
      bonus_points,
      total_points,
      vat_points,
      final_price,
      price,
      vat_amount,
      start_date_base,
      purchase_start_date,
      purchase_end_date,
      end_date_base,
      start_date_bonus,
      end_date_bonus,
      promo_expires_base,
      expiry_days_base,
      promo_expires_bonus,
      expiry_days_bonus,
      start_date_free_wash,
      end_date_free_wash,
      free_wash_description,
      free_wash_quentity,
      free_wash_product,
      free_wash_product_quantity,
      mobile_description,
      is_redeem,
      free_wash_product_description,
      used,
      no_of_orders,
      image_id,
      minimum_items,
      status,
      excluded_days,
      available_days,
      available_times,
    } = data.attributes;
    const isFreeWashDisabled = Number(bonus_points) > 0;
    const isNoProductSelected = !selectedProducts || selectedProducts.length === 0;
    const isFreeWashProductDisabled = isFreeWashDisabled;
    const sectionIds = this.state.sectionSelectedData.map(
      (item: any) => Number(item.id)
    );
    
    return (
      // Customizable Area Start
      <>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <MainContainer>
            <Snackbar
              open={saveStatus.length > 0}
              autoHideDuration={5000}
              anchorOrigin={{ vertical: "top", horizontal: "center" }}
            >
              <Alert
                onClose={() => this.setState({ saveStatus: "" })}
                severity={
                  saveStatus === Strings.goldenPointSaved ||
                  Strings.goldenPointUpdate
                    ? "success"
                    : "error"
                }
              >
                {saveStatus}
              </Alert>
            </Snackbar>

            <Heading>
              {this.isEdit ? Strings.edit : Strings.create} {Strings.pageTitle}
            </Heading>

            {isSaveLoader && <CustomLoader loading={isSaveLoader} />}

            {isLoading && !noData && (
              <LoadingComponent>Loading...</LoadingComponent>
            )}

            {!isLoading && noData && (
              <ErrorLabel>{Strings.somethingWentWrong}</ErrorLabel>
            )}

            {!isLoading && !noData && (
              <>
                <WhiteContainer>
                  <GridContainer>
                    <div>
                      <TextLabel>{Strings.goldenPointName} *</TextLabel>
                      <StyledTextField
                        fullWidth
                        value={name}
                        variant='outlined'
                        placeholder={Strings.enterGoldenPointName}
                        onChange={(e) =>
                          this.onChangeValue("name", e.target.value)
                        }
                      />
                      {error.name && <ErrorLabel>{error.name}</ErrorLabel>}
                    </div>
                    <div>
                      <TextLabel>{Strings.goldenPointNameArabic} *</TextLabel>
                      <StyledTextField
                        fullWidth
                        value={name_arabic}
                        variant='outlined'
                        placeholder={Strings.enterGoldenPointNameArabic}
                        onChange={(e) =>
                          this.onChangeValue("name_arabic", e.target.value)
                        }
                      />
                      {error.name_arabic && (
                        <ErrorLabel>{error.name_arabic}</ErrorLabel>
                      )}
                    </div>
                    <div>
                      <TextLabel>{Strings.goldenPointTextEn}</TextLabel>
                      <StyledTextField
                        fullWidth
                        multiline
                        rows={2}
                        value={golden_point_text_en}
                        variant='outlined'
                        placeholder={Strings.enterGoldenPointText}
                        onChange={(e) =>
                          this.onChangeValue(
                            "golden_point_text_en",
                            e.target.value
                          )
                        }
                      />
                      {error.golden_point_text_en && (
                        <ErrorLabel>{error.golden_point_text_en}</ErrorLabel>
                      )}
                    </div>
                    <div>
                      <TextLabel>{Strings.goldenPointTextAr}</TextLabel>
                      <StyledTextField
                        fullWidth
                        multiline
                        rows={2}
                        value={golden_point_text_ar}
                        variant='outlined'
                        placeholder={Strings.enterGoldenPointText}
                        onChange={(e) =>
                          this.onChangeValue(
                            "golden_point_text_ar",
                            e.target.value
                          )
                        }
                      />
                      {error.golden_point_text_ar && (
                        <ErrorLabel>{error.golden_point_text_ar}</ErrorLabel>
                      )}
                    </div>
                    <div>
                      <TextLabel>{Strings.receiptText}</TextLabel>
                      <StyledTextField
                        fullWidth
                        value={receipt_text}
                        variant='outlined'
                        placeholder={Strings.enterReceiptText}
                        onChange={(e) =>
                          this.onChangeValue("receipt_text", e.target.value)
                        }
                      />
                      {error.receipt_text && (
                        <ErrorLabel>{error.receipt_text}</ErrorLabel>
                      )}
                    </div>
                    <div style={{ position: "relative", marginBottom: "16px" }}>
                      <TextLabel>{Strings.purchaseStartDate}</TextLabel>
                      <StyledDatePicker
                        InputProps={{
                          inputRef: this.purchaseStartDateRef,
                        }}
                        fullWidth
                        inputProps={{
                          "data-test-id": "field-startDate",
                        }}
                        placeholder='DD/MM/YYYY'
                        format='DD/MM/YYYY'
                        value={purchase_start_date}
                        onChange={(e) =>
                          this.onChangeValue("purchase_start_date", e)
                        }
                        disablePast={true}
                        TextFieldComponent={(params) =>
                          (
                            <TextField
                              {...params}
                              helperText=''
                              error={!!error.purchase_start_date}
                            />
                          ) as any
                        }
                      />
                      {error.purchase_start_date && (
                        <ErrorLabel
                          style={{
                            position: "absolute",
                            bottom: "-20px",
                            left: 0,
                          }}
                        >
                          {error.purchase_start_date}
                        </ErrorLabel>
                      )}
                    </div>
                    <div>
                      <TextLabel>{Strings.purchaseEndDate}</TextLabel>
                      <StyledDatePicker
                        InputProps={{
                          inputRef: this.purchaseEndDateRef,
                        }}
                        fullWidth
                        inputProps={{
                          "data-test-id": "field-startDate",
                        }}
                        placeholder='DD/MM/YYYY'
                        format='DD/MM/YYYY'
                        value={purchase_end_date}
                        onChange={(e) =>
                          this.onChangeValue("purchase_end_date", e)
                        }
                        disablePast={true}
                        TextFieldComponent={(params) =>
                          (
                            <TextField
                              {...params}
                              helperText=''
                              error={false}
                            />
                          ) as any
                        }
                      />
                      {/* <CalenderIcon
                        onClick={() => this.purchaseEndDateRef?.current?.click()}
                        src={calenderIcon}
                      /> */}
                      {error.purchase_end_date && (
                        <ErrorLabel>{error.purchase_end_date}</ErrorLabel>
                      )}
                    </div>
                    <div>
                      <TextLabel>{Strings.basePoint} *</TextLabel>
                      <StyledTextField
                        fullWidth
                        type='text'
                        value={base_points}
                        inputMode='decimal'
                        variant='outlined'
                        placeholder='0'
                        // placeholder={Strings.enterBasePoint || "0"}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position='end'>
                              <CustomSpan>Points</CustomSpan>
                            </InputAdornment>
                          ),
                        }}
                        onChange={(e) =>
                          this.onChangeValue("base_points", e.target.value)
                        }
                      />
                      {error.base_points && (
                        <ErrorLabel>{error.base_points}</ErrorLabel>
                      )}
                    </div>
                    <div>
                      <TextLabel>{Strings.startDateBase}</TextLabel>
                      <StyledDatePicker
                        InputProps={{
                          inputRef: this.baseStartDateRef,
                        }}
                        fullWidth
                        inputProps={{
                          "data-test-id": "field-startDate",
                        }}
                        placeholder='DD/MM/YYYY'
                        format='DD/MM/YYYY'
                        value={start_date_base}
                        onChange={(e) =>
                          this.onChangeValue("start_date_base", e)
                        }
                        disablePast={true}
                        TextFieldComponent={(params) =>
                          (
                            <TextField
                              {...params}
                              helperText=''
                              error={false}
                            />
                          ) as any
                        }
                      />
                      {/* <CalenderIcon
                        onClick={() => this.baseStartDateRef?.current?.click()}
                        src={calenderIcon}
                      /> */}
                      {error.start_date_base && (
                        <ErrorLabel>{error.start_date_base}</ErrorLabel>
                      )}
                    </div>
                    <div>
                      <SwitchRow>
                        <TextLabel>
                          {promo_expires_base
                            ? Strings.expiryDaysBase
                            : Strings.endDateBase}
                        </TextLabel>
                        <FormControlLabel
                          control={
                            <Switch
                              color='primary'
                              data-test-id='switch-promo_expires_base'
                              checked={!!promo_expires_base}
                              onChange={(e) =>
                                this.onChangeValue(
                                  "promo_expires_base",
                                  e.target.checked
                                )
                              }
                            />
                          }
                          label={Strings.useNumberOfDays}
                        />
                      </SwitchRow>
                      {promo_expires_base ? (
                        <StyledTextField
                          fullWidth
                          type='number'
                          variant='outlined'
                          placeholder={Strings.enterNumberOfDays}
                          inputProps={{
                            min: 0,
                            "data-test-id": "field-expiry_days_base",
                          }}
                          value={expiry_days_base ?? ""}
                          onChange={(e) =>
                            this.onChangeValue(
                              "expiry_days_base",
                              e.target.value
                            )
                          }
                        />
                      ) : (
                        <StyledDatePicker
                          InputProps={{
                            inputRef: this.baseEndDateRef,
                          }}
                          fullWidth
                          inputProps={{
                            "data-test-id": "field-startDate",
                          }}
                          placeholder='DD/MM/YYYY'
                          format='DD/MM/YYYY'
                          value={end_date_base}
                          onChange={(e) =>
                            this.onChangeValue("end_date_base", e)
                          }
                          disablePast={true}
                          TextFieldComponent={(params) =>
                            (
                              <TextField
                                {...params}
                                helperText=''
                                error={false}
                              />
                            ) as any
                          }
                        />
                      )}
                      {promo_expires_base
                        ? error.expiry_days_base && (
                            <ErrorLabel>{error.expiry_days_base}</ErrorLabel>
                          )
                        : error.end_date_base && (
                            <ErrorLabel>{error.end_date_base}</ErrorLabel>
                          )}
                    </div>
                    <div>
                      <TextLabel>{Strings.bonusPoint}</TextLabel>
                      <StyledTextField
                        fullWidth
                        value={bonus_points}
                        variant='outlined'
                        placeholder={"0"}
                        // placeholder={Strings.enterBonusPoint}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position='end'>
                              <CustomSpan>Points</CustomSpan>
                            </InputAdornment>
                          ),
                        }}
                        onChange={(e) =>
                          this.onChangeValue("bonus_points", e.target.value)
                        }
                      />
                      {error.bonus_points && (
                        <ErrorLabel>{error.bonus_points}</ErrorLabel>
                      )}
                    </div>
                    <div>
                      <TextLabel>{Strings.startDateBonus}</TextLabel>
                      <StyledDatePicker
                        InputProps={{
                          inputRef: this.bonusStartDateRef,
                        }}
                        fullWidth
                        inputProps={{
                          "data-test-id": "field-startDate",
                        }}
                        placeholder='DD/MM/YYYY'
                        format='DD/MM/YYYY'
                        value={start_date_bonus}
                        onChange={(e) =>
                          this.onChangeValue("start_date_bonus", e)
                        }
                        disablePast={true}
                        TextFieldComponent={(params) =>
                          (
                            <TextField
                              {...params}
                              helperText=''
                              error={false}
                            />
                          ) as any
                        }
                      />
                      {error.start_date_bonus && (
                        <ErrorLabel>{error.start_date_bonus}</ErrorLabel>
                      )}
                    </div>
                    <div>
                      <SwitchRow>
                        <TextLabel>
                          {promo_expires_bonus
                            ? Strings.expiryDaysBonus
                            : Strings.endDateBonus}{" "}
                        </TextLabel>
                        <FormControlLabel
                          control={
                            <Switch
                              color='primary'
                              data-test-id='switch-promo_expires_bonus'
                              checked={!!promo_expires_bonus}
                              onChange={(e) =>
                                this.onChangeValue(
                                  "promo_expires_bonus",
                                  e.target.checked
                                )
                              }
                            />
                          }
                          label={Strings.useNumberOfDays}
                        />
                      </SwitchRow>
                      {promo_expires_bonus ? (
                        <StyledTextField
                          fullWidth
                          type='number'
                          variant='outlined'
                          placeholder={Strings.enterNumberOfDays}
                          inputProps={{
                            min: 0,
                            "data-test-id": "field-expiry_days_bonus",
                          }}
                          value={expiry_days_bonus ?? ""}
                          onChange={(e) =>
                            this.onChangeValue(
                              "expiry_days_bonus",
                              e.target.value
                            )
                          }
                        />
                      ) : (
                        <StyledDatePicker
                          InputProps={{
                            inputRef: this.bonusEndDateRef,
                          }}
                          fullWidth
                          inputProps={{
                            "data-test-id": "field-startDate",
                          }}
                          placeholder='DD/MM/YYYY'
                          format='DD/MM/YYYY'
                          value={end_date_bonus}
                          onChange={(e) =>
                            this.onChangeValue("end_date_bonus", e)
                          }
                          disablePast={true}
                          TextFieldComponent={(params) =>
                            (
                              <TextField
                                {...params}
                                helperText=''
                                error={false}
                              />
                            ) as any
                          }
                        />
                      )}
                      {promo_expires_bonus
                        ? error.expiry_days_bonus && (
                            <ErrorLabel>{error.expiry_days_bonus}</ErrorLabel>
                          )
                        : error.end_date_bonus && (
                            <ErrorLabel>{error.end_date_bonus}</ErrorLabel>
                          )}
                    </div>

                    <div>
                      <TextLabel>{Strings.totalPoint} *</TextLabel>
                      <StyledTextField
                        type='number'
                        value={total_points}
                        variant='outlined'
                        fullWidth
                        placeholder='Auto calculated'
                        InputProps={{ readOnly: true }}
                      />
                      {error.total_points && (
                        <ErrorLabel>{error.total_points}</ErrorLabel>
                      )}
                    </div>
                    {/* <div>
                      <TextLabel>{Strings.vatPoint} *</TextLabel>
                      <StyledTextField
                        type='number'
                        value={vat_points}
                        variant='outlined'
                        fullWidth
                        placeholder='Auto calculated'
                        InputProps={{ readOnly: true }}
                      />
                      {error.vat_points && (
                        <ErrorLabel>{error.vat_points}</ErrorLabel>
                      )}
                    </div> */}
                    <div>
                      <TextLabel>{Strings.price} *</TextLabel>
                      <StyledTextField
                        fullWidth
                        value={price}
                        variant='outlined'
                        placeholder={Strings.enterPrice}
                        type='text'
                        inputMode='decimal'
                        onChange={(e) => {
                          const newPrice = e.target.value;
                          this.onChangeValue("price", newPrice);
                        }}
                      />
                      {error.price && <ErrorLabel>{error.price}</ErrorLabel>}
                    </div>

                    <div>
                      <TextLabel>{Strings.tax}</TextLabel>
                      <StyledTextField
                        fullWidth
                        value={vat}
                        variant='outlined'
                        type='text'
                        placeholder='VAT (15%)'
                        InputProps={{
                          readOnly: true,
                        }}
                        onChange={(e) =>
                          this.onChangeValue("vat", e.target.value)
                        }
                      />
                      {error.vat && <ErrorLabel>{error.vat}</ErrorLabel>}
                    </div>
                    <div>
                      <TextLabel>{Strings.taxAmount}</TextLabel>
                      <StyledTextField
                        fullWidth
                        value={vat_amount}
                        variant='outlined'
                        type='number'
                        placeholder='VAT (15%)'
                        InputProps={{
                          readOnly: true,
                        }}
                        onChange={(e) =>
                          this.onChangeValue("vat_amount", e.target.value)
                        }
                      />
                      {error.vat_amount && (
                        <ErrorLabel>{error.vat_amount}</ErrorLabel>
                      )}
                    </div>
                    <div>
                      <TextLabel>{Strings.finalPrice}</TextLabel>
                      <StyledTextField
                        fullWidth
                        value={final_price}
                        variant='outlined'
                        placeholder={Strings.enterPrice}
                        onChange={(e) =>
                          this.onChangeValue("final_price", e.target.value)
                        }
                      />
                      {error.final_price && (
                        <ErrorLabel>{error.final_price}</ErrorLabel>
                      )}
                    </div>
                    <div>
                      <TextLabel>{Strings.platform} *</TextLabel>
                      <CustomSearchableMultiSelect
                        id='platform'
                        name='platform'
                        dataTestId='platformDropdown'
                        checkSelectAllText={() => {}}
                        value={selectedPlatform}
                        optionList={platformList.map((p) => ({
                          id: p.id,
                          option: p.option || p.name || p.label || "",
                        }))}
                        placeHolderText={Strings.selectPlatform}
                        changeInputOnClear
                        handleScroll={() => {}}
                        handleClickOnSelectAll={() => {}}
                        isOnBlurFunction={() => {}}
                        debouncedFunction={(getValue: string) => {}}
                        handleSelectOptions={(
                          values: IOption[],
                          option: IOption
                        ) => {
                          const convertedValues = values.map((v) => ({
                            id: v.id.toString(),
                            option: v.option || v.name || "",
                          }));
                          const convertedOption = {
                            id: option.id.toString(),
                            option: option.option || option.name || "",
                          };
                          this.handlePlatformMultiSelect(
                            convertedValues,
                            convertedOption
                          );
                        }}
                        emptyDataMessage='No Platforms Found'
                        handleEmptyAutoSelectValue={() => {}}
                        selectedOptionForList={platformSelectedOptionForList}
                        isError={Boolean(error.platform_ids)}
                      />
                      {error.platform_ids && (
                        <ErrorLabel>{error.platform_ids}</ErrorLabel>
                      )}
                    </div>
                    {selectedPlatforms.some(
                      (p: IOption) =>
                        p.option?.toLowerCase() === "app" ||
                        p.option?.toLowerCase() === "select all"
                    ) && (
                      <div className='mt-3'>
                        <TextLabel>{Strings.mobileDescription} </TextLabel>
                        <StyledTextField
                          type='text'
                          value={mobile_description}
                          variant='outlined'
                          fullWidth
                          placeholder='Enter Description'
                          onChange={(e) =>
                            this.onChangeValue(
                              "mobile_description",
                              e.target.value
                            )
                          }
                        />
                        {error.mobile_description && (
                          <ErrorLabel>{error.mobile_description}</ErrorLabel>
                        )}
                      </div>
                    )}

                    <div>
                      <TextLabel>{Strings.region} *</TextLabel>
                      <CustomSearchableMultiSelect
                        id='region'
                        name='region'
                        dataTestId='regionDropdown'
                        checkSelectAllText={() => {}}
                        value={regionSelectedData}
                        optionList={regionList.map((r) => ({
                          id: r.id,
                          option: r.name,
                        }))}
                        placeHolderText={Strings.selectRegion}
                        changeInputOnClear
                        handleScroll={() => {}}
                        handleClickOnSelectAll={() => {}}
                        isOnBlurFunction={() => {}}
                        debouncedFunction={(getValue: string) => {}}
                        handleSelectOptions={(values: any[], option: any) => {
                          this.handleRegionMultiSelect(values, option);
                        }}
                        emptyDataMessage='No Region Found'
                        handleEmptyAutoSelectValue={() => {}}
                        selectedOptionForList={selectedRegionsForList}
                        isError={Boolean(error.region_ids)}
                      />
                      {error.region_ids && (
                        <ErrorLabel>{error.region_ids}</ErrorLabel>
                      )}
                    </div>
                    <div>
                      <TextLabel>{Strings.area}</TextLabel>
                      <CustomSearchableMultiSelect
                        id='area'
                        name='area'
                        dataTestId='areaDropdown'
                        checkSelectAllText={() => {}}
                        value={areaSelectedData}
                        optionList={areaList.map((a) => ({
                          id: a.id,
                          option: a.name,
                        }))}
                        placeHolderText={Strings.selectArea}
                        changeInputOnClear
                        handleScroll={() => {}}
                        handleClickOnSelectAll={() => {}}
                        isOnBlurFunction={() => {}}
                        debouncedFunction={(getValue: string) => {}}
                        handleSelectOptions={(values: any[], option: any) => {
                          this.handleAreaMultiSelect(values, option);
                        }}
                        emptyDataMessage='No Area Found'
                        handleEmptyAutoSelectValue={() => {}}
                        selectedOptionForList={selectedAreasForList}
                        isError={Boolean(error.area_ids)}
                      />
                      {error.area_ids && (
                        <ErrorLabel>{error.area_ids}</ErrorLabel>
                      )}
                    </div>
                    <div>
                      <TextLabel>{Strings.section} *</TextLabel>
                      <CustomSearchableMultiSelect
                        id='section'
                        name='section'
                        dataTestId='sectionDropdown'
                        checkSelectAllText={() => {}}
                        value={sectionSelectedData}
                        optionList={sectionList.map((r) => ({
                          id: r.id,
                          option: r.option,
                        }))}
                        placeHolderText={Strings.selectSection}
                        changeInputOnClear
                        handleScroll={() => {}}
                        handleClickOnSelectAll={() => {}}
                        isOnBlurFunction={() => {}}
                        debouncedFunction={(getValue: string) => {}}
                        handleSelectOptions={(values: any[], option: any) => {
                          this.handleSectionMultiSelect(values, option);
                        }}
                        handleEmptyAutoSelectValue={() => {
                          this.handleClearSectionSelection();
                        }}
                        emptyDataMessage='No Section Found'
                        selectedOptionForList={selectedSectionsForList}
                        isError={Boolean(error.sectiions)}
                      />
                      {error.sectiions && (
                        <ErrorLabel>{error.sectiions}</ErrorLabel>
                      )}
                    </div>
                    <div>
                      <TextLabel>{Strings.product}</TextLabel>
                      <CustomSearchableMultiSelect
                        id='product'
                        name='product'
                        dataTestId='productDropdown'
                        checkSelectAllText={() => {}}
                        value={selectedProducts}
                        optionList={productList.map((a) => ({
                          id: a.id,
                          option: String(a.name),
                        }))}
                        placeHolderText={Strings.selectProduct}
                        changeInputOnClear
                        handleScroll={() => {}}
                        handleClickOnSelectAll={() => {}}
                        isOnBlurFunction={() => {}}
                        debouncedFunction={(getValue: string) => {}}
                        handleSelectOptions={(values: any[], option: any) => {
                          this.handleProductMultiSelect(values, option);
                        }}
                        emptyDataMessage='No Product Found'
                        handleEmptyAutoSelectValue={() => {}}
                        selectedOptionForList={selectedProductsForList}
                        isError={Boolean(error.area_ids)}
                      />
                      {error.products && (
                        <ErrorLabel>{error.products}</ErrorLabel>
                      )}
                    </div>
                    <div>
                      <TextLabel>{Strings.services} *</TextLabel>
                      <CustomSearchableMultiSelect
                        id='services'
                        name='services'
                        dataTestId='servicesDropdown'
                        checkSelectAllText={() => {}}
                        value={selectedServices}
                        optionList={serviceList.map((r) => ({
                          id: r.id,
                          option: r.name,
                        }))}
                        placeHolderText={Strings.selectServices}
                        changeInputOnClear
                        handleScroll={() => {}}
                        handleClickOnSelectAll={() => {}}
                        isOnBlurFunction={() => {}}
                        debouncedFunction={(getValue: string) => {}}
                        handleSelectOptions={(values: any[], option: any) => {
                          this.handleServiceMultiSelect(values, option);
                        }}
                        emptyDataMessage='No Services Found'
                        handleEmptyAutoSelectValue={() => {}}
                        selectedOptionForList={selectedServicesForList}
                        isError={Boolean(error.service_ids)}
                      />
                      {error.service_ids && (
                        <ErrorLabel>{error.service_ids}</ErrorLabel>
                      )}
                    </div>

                    {selectedPlatforms.find(
                      (p: IOption) => p.id === 1 || p.id === "1"
                    ) && (
                      <div>
                        <TextLabel>{Strings.store}</TextLabel>
                        <CustomSearchableMultiSelect
                          id='store'
                          name='store'
                          dataTestId='storeDropdown'
                          checkSelectAllText={() => {}}
                          value={selectedStoresForList}
                          optionList={storeList.map((s) => ({
                            id: s.id,
                            option: s.store_name || s.name || s.label || "",
                          }))}
                          placeHolderText={Strings.selectStore}
                          changeInputOnClear
                          handleScroll={() => {}}
                          handleClickOnSelectAll={() => {}}
                          isOnBlurFunction={() => {}}
                          debouncedFunction={(getValue: string) => {}}
                          handleSelectOptions={(
                            values: IOption[],
                            option: IOption
                          ) => {
                            const convertedValues = values.map((v) => ({
                              id: v.id.toString(),
                              option: v.option || v.name || "",
                            }));
                            const convertedOption = {
                              id: option.id.toString(),
                              option: option.option || option.name || "",
                            };
                            this.handleStoreMultiSelect(
                              convertedValues,
                              convertedOption
                            );
                          }}
                          emptyDataMessage='No Stores Found'
                          handleEmptyAutoSelectValue={() => {}}
                          selectedOptionForList={selectedStoresForList}
                          isError={Boolean(error.store_management_ids)}
                        />
                        {error.store_management_ids && (
                          <ErrorLabel>{error.store_management_ids}</ErrorLabel>
                        )}
                      </div>
                    )}
                    <div>
                      <TextLabel>{Strings.isRedeem}</TextLabel>
                      <input
                        type='checkbox'
                        checked={this.state.is_redeem}
                        onChange={(e) =>
                          this.setState({ is_redeem: e.target.checked })
                        }
                      />
                      {error.is_redeem && (
                        <ErrorLabel>{error.is_redeem}</ErrorLabel>
                      )}
                    </div>
                    <div>
                      <TextLabel>{Strings.usageType}</TextLabel>
                      <AutocompleteSelect
                        fieldName='usage_type'
                        placeholder={Strings.selectUsageType}
                        options={usageTypes.map((ut) => ({
                          id: ut.id,
                          option: ut.name,
                        }))}
                        value={used}
                        disableClear={true}
                        isRadioButtonShow={true}
                        onChange={(_event: React.ChangeEvent, value: any) => {
                          this.onChangeValue("used", value?.id || "all_orders");
                        }}
                      />
                      {error.used && <ErrorLabel>{error.used}</ErrorLabel>}
                    </div>
                    {used === "specific_number_of_orders" && (
                      <div>
                        <TextLabel>{Strings.noOfOrders}</TextLabel>
                        <StyledTextField
                          fullWidth
                          type='number'
                          value={no_of_orders || ""}
                          variant='outlined'
                          placeholder={Strings.enterNoOfOrders}
                          onChange={(e) => {
                            const value = e.target.value
                              ? parseInt(e.target.value)
                              : null;
                            this.onChangeValue("no_of_orders", value);
                          }}
                        />
                        {error.no_of_orders && (
                          <ErrorLabel>{error.no_of_orders}</ErrorLabel>
                        )}
                      </div>
                    )}
                    <div className='mt-3'>
                      <TextLabel>Image *</TextLabel>
                      <CustomImageRadioDropdown
                        id='imageSelector'
                        name='imageSelector'
                        value={this.state.selectedImage}
                        optionList={this.state.imageDropdownOptions}
                        placeHolderText='Select Image'
                        debouncedFunction={(txt: string) => {
                          this.setState(
                            {
                              productIconSearchText: txt,
                              productNextPage: 1,
                              imageDropdownOptions: [],
                            },
                            () => {
                              this.getImages();
                            }
                          );
                        }}
                        handleSelectOption={(value: {
                          id: string | number;
                          option: string;
                          image: string;
                        }) => this.handleImageSelect(value)}
                        selectedItem={this.state.selectedImage}
                        isError={Boolean(error.image_id)}
                      />
                      {error.image_id && (
                        <ErrorLabel>{error.image_id}</ErrorLabel>
                      )}
                    </div>

                    <div>
                      <TextLabel>{Strings.freeWashProductQty} </TextLabel>
                      <StyledTextField
                        type='number'
                        value={free_wash_quentity}
                        variant='outlined'
                        fullWidth
                        placeholder='Enter Quantity'
                        disabled={isFreeWashProductDisabled}
                        onChange={(e) =>
                          this.onChangeValue(
                            "free_wash_quentity",
                            e.target.value
                          )
                        }
                      />
                      {error.free_wash_quentity && (
                        <ErrorLabel>{error.free_wash_quentity}</ErrorLabel>
                      )}
                    </div>
                    <div>
                      <TextLabel>{Strings.freeWashProduct} </TextLabel>

                      <DynamicItemRow>
                        <Select
                          value={this.state.freeWashItemType}
                          onChange={(e) => {
                            const value = e.target.value as string;

                            this.setState(
                              {
                                freeWashItemType: value,
                              },
                              () => {
                                if (value === "parent_product") {
                                  this.productNextPage = 1;
                                  this.getProductGroupList();
                                } else {
                                  this.productNextPage = 1;
                                  this.getFreeWashProducts(sectionIds);
                                  
                                }
                              }
                            );
                          }}
                          variant='outlined'
                          fullWidth
                          style={{ marginRight: 8 }}
                        >
                          {itemTypes.map((type) => (
                            <MenuItem key={type.id} value={type.id}>
                              {type.label}
                            </MenuItem>
                          ))}
                        </Select>

                        <CustomSearchableMultiSelect
                          id='free_wash_product'
                          name='free_wash_product'
                          disabled={isFreeWashProductDisabled}
                          dataTestId='freeeWashProductDropdown'
                          checkSelectAllText={() => {}}
                          value={selectedFreeWashProducts}
                          optionList={
                            this.state.freeWashItemType === "parent_product"
                              ? this.state.productGroupList.map((item) => ({
                                  id: item.id,
                                  option: String(item.name),
                                }))
                              : productList.map((item) => ({
                                  id: item.id,
                                  option: String(item.name),
                                }))
                          }
                          placeHolderText={
                            this.state.sectionSelectedData.length === 0
                              ? "Select Section First"
                              : this.state.freeWashItemType === "parent_product"
                              ? "Select Product Group"
                              : "Select Product"
                          }
                          changeInputOnClear
                          handleScroll={() => {}}
                          handleClickOnSelectAll={() => {}}
                          isOnBlurFunction={() => {}}
                          debouncedFunction={() => {}}
                          handleSelectOptions={(values: any[], option: any) => {
                            this.handleFreeWashProductMultiSelect(
                              values,
                              option
                            );
                          }}
                          emptyDataMessage='No Product Found'
                          handleEmptyAutoSelectValue={() => {}}
                          selectedOptionForList={
                            selectedFreeWashProductsForList
                          }
                        />
                      </DynamicItemRow>

                      {error.free_wash_product && (
                        <ErrorLabel>{error.free_wash_product}</ErrorLabel>
                      )}
                    </div>
                    <div>
                      <TextLabel>
                        {Strings.freeWashProductDescription}
                      </TextLabel>
                      <StyledTextField
                        type='text' // user can type text
                        value={free_wash_description || ""}
                        variant='outlined'
                        fullWidth
                        placeholder='Enter description'
                        disabled={isFreeWashProductDisabled}
                        onChange={(e) =>
                          this.onChangeValue(
                            "free_wash_description",
                            e.target.value
                          )
                        }
                      />
                      {error.free_wash_description && (
                        <ErrorLabel>{error.free_wash_description}</ErrorLabel>
                      )}
                    </div>
                    <div>
                      <TextLabel>{Strings.startDateFreewash} </TextLabel>
                      <StyledDatePicker
                        InputProps={{
                          inputRef: this.freewashStartDateRef,
                        }}
                        fullWidth
                        inputProps={{
                          "data-test-id": "field-startDate",
                        }}
                        placeholder='DD/MM/YYYY'
                        format='DD/MM/YYYY'
                        value={start_date_free_wash}
                        disabled={isFreeWashProductDisabled}
                        onChange={(e) =>
                          this.onChangeValue("start_date_free_wash", e)
                        }
                        disablePast={true}
                        TextFieldComponent={(params) =>
                          (
                            <TextField
                              {...params}
                              helperText=''
                              error={false}
                            />
                          ) as any
                        }
                      />
                      {/* <CalenderIcon
                        onClick={() => this.freewashStartDateRef?.current?.click()}
                        src={calenderIcon}
                      /> */}
                      {error.start_date_free_wash && (
                        <ErrorLabel>{error.start_date_free_wash}</ErrorLabel>
                      )}
                    </div>
                    <div>
                      <TextLabel>{Strings.endDateFreeWash} </TextLabel>
                      <StyledDatePicker
                        InputProps={{
                          inputRef: this.freewashEndDateRef,
                        }}
                        fullWidth
                        inputProps={{
                          "data-test-id": "field-startDate",
                        }}
                        placeholder='DD/MM/YYYY'
                        format='DD/MM/YYYY'
                        value={end_date_free_wash}
                        disabled={isFreeWashProductDisabled}
                        onChange={(e) =>
                          this.onChangeValue("end_date_free_wash", e)
                        }
                        // disablePast={!this.state.data?.id}
                        disablePast={true}
                        TextFieldComponent={(params) =>
                          (
                            <TextField
                              {...params}
                              helperText=''
                              error={false}
                            />
                          ) as any
                        }
                      />
                      {/* <CalenderIcon
                        onClick={() => this.freewashEndDateRef?.current?.click()}
                        src={calenderIcon}
                      /> */}
                      {error.end_date_free_wash && (
                        <ErrorLabel>{error.end_date_free_wash}</ErrorLabel>
                      )}
                    </div>
                    <div>
                      <TextLabel>{Strings.status} *</TextLabel>
                      <AutocompleteSelect
                        fieldName='status'
                        placeholder={Strings.selectStatus}
                        options={[
                          { id: true, option: "Active" },
                          { id: false, option: "Inactive" },
                        ]}
                        value={status}
                        disableClear={true}
                        isRadioButtonShow={true}
                        onChange={(_event: React.ChangeEvent, value: any) => {
                          this.onChangeValue("status", value?.id ?? true);
                        }}
                      />
                      {error.status && <ErrorLabel>{error.status}</ErrorLabel>}
                    </div>
                    <div>
                      <TextLabel>{Strings.availableDays}</TextLabel>

                      <CustomSearchableMultiSelect
                        id='field-excludeDay'
                        name='field-excludeDay'
                        dataTestId='field-excludeDay'
                        placeHolderText={Strings.selectDay}
                        changeInputOnClear
                        emptyDataMessage='No Data Found'
                        handleScroll={() => {}}
                        checkSelectAllText={() => {}}
                        handleClickOnSelectAll={() => {}}
                        handleEmptyAutoSelectValue={() => {}}
                        debouncedFunction={(getValue: string) => {
                          if (getValue === "") {
                            this.handleClearMultiSelect("excludeDay");
                          }
                        }}
                        optionList={excludeDayList}
                        value={this.state.selectedExcludeDays}
                        selectedOptionForList={
                          this.state.excludeDaysSelectedOptionForList
                        }
                        handleSelectOptions={(
                          value: { id: string; option: string }[],
                          option: { id: string; option: string }
                        ) => {
                          this.handleExcludeDaysMultiSelect(value, option);
                        }}
                      />
                      {error.exclude_days && (
                        <ErrorLabel>{error.exclude_days}</ErrorLabel>
                      )}
                    </div>
                  </GridContainer>

                  <br />
                  <GridContainer>{this.renderExcludedTimes()}</GridContainer>
                </WhiteContainer>

                <BottomContainer>
                  <button
                    data-test-id='btn-cancel'
                    onClick={() => this.clickCancel()}
                    className='cancel'
                  >
                    {Strings.cancel}
                  </button>
                  <button
                    data-test-id='btn-submit'
                    className='add'
                    onClick={() => this.onSubmit()}
                  >
                    {this.isEdit ? Strings.save : Strings.add}{" "}
                    {Strings.pageTitle}
                  </button>
                </BottomContainer>
              </>
            )}
            <br />
            <br />
          </MainContainer>
        </MuiPickersUtilsProvider>
      </>
      // Customizable Area End
    );
  }
}

// Customizable Area Start
export const ErrorLabel = styled("div")({
  fontSize: 14,
  marginTop: 6,
  fontWeight: 500,
  color: "#EC4E20",
  lineHeight: "22px",
  letterSpacing: "0.25px",
  fontFamily: "Montserrat",
});

const LoadingComponent = styled("div")({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: "200px",
  fontSize: 16,
  color: "#204B9C",
});

export const LabelStyled = styled("span")({
  fontWeight: 500,
  fontSize: "16px",
  lineHeight: "24px",
});

export const CustomSpan = styled("span")({
  color: "#000",
  fontSize: "14px",
  fontWeight: 500,
  "@media only screen and (max-width: 1024px)": {
    fontSize: "13px",
  },
});

export const StyledTextField = styled(TextField)({
  borderRadius: 8,
  "& .MuiOutlinedInput-root": {
    borderRadius: 8,
  },
  "@media only screen and (max-width: 1024px)": {
    "& .MuiInputBase-input": {
      fontSize: "12px",
      padding: "14.9px 14px",
    },
  },
});

export const TextLabel = styled("label")({
  display: "block",
  fontSize: 16,
  lineHeight: "24px",
  fontWeight: 600,
  paddingBottom: 4,
  color: "var(--neutrals-cool-gray-700, #334155)",
  "@media only screen and (max-width: 1024px)": {
    fontSize: "13px",
  },
});

export const SwitchRow = styled("div")({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: 8,
});

export const GridContainer = styled("div")({
  display: "grid",
  gridGap: 32,
  gridTemplateColumns: "1fr 1fr",
});

const LeftContainer = styled("div")({
  "& > div": {
    paddingBottom: 32,
  },
});

export const WhiteContainer = styled("div")({
  borderRadius: 12,
  background: "#FFF",
  padding: "24px 32px",
  boxShadow:
    "0px 8px 32px 0px rgba(0, 0, 0, 0.06), 0px 4px 8px 0px rgba(0, 0, 0, 0.03)",
});

export const Heading = styled("h2")({
  color: "#000",
  fontSize: 24,
  fontWeight: 600,
  paddingBottom: 25,
  "@media only screen and (max-width: 1024px)": {
    fontSize: "16px",
  },
});

export const BottomContainer = styled("div")({
  gap: 32,
  display: "flex",
  paddingTop: 48,
  "& > button": {
    fontSize: 16,
    padding: 16,
    minWidth: 126,
    border: "none",
    fontWeight: 700,
    borderRadius: 8,
    cursor: "pointer",
    lineHeight: "24px",
    alignItems: "center",
    display: "inline-flex",
    justifyContent: "center",
    fontFamily: "Montserrat",
    "&:disabled": {
      opacity: 0.5,
    },
  },
  "& > .add": {
    color: "white",
    background: "var(--primary, #204B9C)",
    "@media only screen and (max-width: 1024px)": {
      width: "126px",
      height: "44px",
    },
  },
  "& > .cancel": {
    color: "#64748B",
    background: "var(--primary, #F1F5F9)",
    "@media only screen and (max-width: 1024px)": {
      width: "126px",
      height: "44px",
    },
  },
});

export const MainContainer = styled(Box)({
  paddingTop: "25px",
});

const DynamicSection = styled("div")({
  marginBottom: 24,
});

const SectionHeader = styled("div")({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginBottom: 12,
});

const DynamicItemRow = styled("div")({
  display: "flex",
  alignItems: "center",
  marginBottom: 12,
  gap: 8,
});

const StyledDatePicker = styled(DatePicker)({
  "& .MuiInputBase-input": {
    borderRadius: 8,
    minHeight: "1.1876em",
    padding: "17.5px 14px",
    border: "1px solid var(--border, #ECECEC)",
    boxShadow: "0px 0px 1px rgba(0, 0, 0, 0.87)",
    "&:hover": {
      border: "1px solid rgba(0, 0, 0, 0.87)",
    },
  },
  "& .MuiInput-underline::before, & .MuiInput-underline::after": {
    border: "none !important",
  },
  "@media only screen and (max-width: 1024px)": {
    "& .MuiInputBase-input": {
      fontSize: "12px",
      padding: "14.9px 14px",
    },
  },
});

const CalenderIcon = styled("img")({
  top: "50%",
  right: 16,
  position: "absolute",
  transform: "translateY(-50%)",
});

export default GoldenPointCreate;
